/* eslint-disable jsx-a11y/anchor-is-valid */

import HeaderDataViewFilter from '@/compoments/HeaderDataViewFilter'
import PageLoader from '@/compoments/PageLoader'
import { useGetDispatcherCustomerHistoryQuery } from '@/services/dispatcher/dispather'
import { useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import HistoryTab from './parts/HistoryTab'
import UserPart from './parts/UserPart'
import UncomingTab from './parts/UncomingTab'
import FeedbackTab from './parts/FeedbackTab'

const CustomerPage = () => {
    const { id } = useParams()

    const [searchParams] = useSearchParams()
    const queryString = searchParams.toString()
    const { data, isLoading } = useGetDispatcherCustomerHistoryQuery(
        {
            id: Number(id),
            query: `no_limit=true&${queryString}`,
        },
        { skip: !id || !searchParams.get('startDate') },
    )
    const pageData = data?.data

    const tabs = [
        {
            name: 'Service History',
            id: 1,
        },
        {
            name: 'Upcoming Appointments',
            id: 2,
        },
        {
            name: 'Feedback & Ratings',
            id: 3,
        },
    ]
    const [activeTab, setActiveTab] = useState(tabs[0].id)

    if (isLoading) {
        return <PageLoader />
    }
    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <UserPart data={pageData?.customer} />
                <div className="table-group flex flex-col">
                    <div className="table-filter-actions">
                        {tabs &&
                            tabs.map((el, index) => (
                                <button
                                    data-tab-link=""
                                    onClick={() => setActiveTab(el.id)}
                                    className={`btn full-radius btn--xs btn-tab-custom ${activeTab === el.id ? 'active-tab' : ''}`}
                                    key={index}
                                >
                                    <span>{el.name}</span>
                                </button>
                            ))}
                    </div>
                    <HeaderDataViewFilter />

                    <div className="table-body table-responsive p-0">
                        {activeTab === 1 && <HistoryTab data={pageData} />}
                        {activeTab === 2 && <UncomingTab />}
                        {activeTab === 3 && <FeedbackTab />}
                    </div>
                </div>
            </div>
        </main>
    )
}

export default CustomerPage
